export interface Numerator {
    numeratorType: string;
    year: number ;
    serie: string;
    number: string;
    objectTypeId: number;
    numberString: string;
    isNew: boolean;
    isNumeratorReadOnly: boolean;
    isNumberReadOnly: boolean;
}

export enum NumeratorType {
    project = 1,
    order = 2,
    worklog = 3,
    service = 4,
    consultations = 5
}

// export class EntityCode {
//     constructor(
//       public id: number,
//       public code: string) { }
//   }